/**
 * FairwayBid – Inhalte der Golfanlagenseite
 *
 * Eine Golfanlage zahlt hier nichts. Sie muss also nicht vom Preis überzeugt
 * werden, sondern davon, dass der Weg über FairwayBid besser ist als der
 * gewohnte: anrufen, warten, nachfassen, drei ungleiche Angebote im
 * Postfach, im Vorstand vorlegen.
 *
 * Wichtig beim Ändern: Hier steht kein Satz mit erfundenen Zahlen. Wie viel
 * eine Anlage spart, wissen wir nicht – das hinge von ihr ab, und eine
 * erfundene Prozentzahl fliegt beim ersten Nachrechnen auf. Was hier steht,
 * sind Mechanismen: Wettbewerb auf dieselbe Spezifikation, sichtbare
 * Nebenkosten, keine Notbeschaffung, kein Mitgliedsbeitrag. Die wirken
 * ohnehin stärker als eine Zahl, die niemand belegen kann.
 */

export const CLUB_PAGE_ID = 'fuer-golfanlagen';
export const CLUB_TYPE = 'fwb-golfanlagen';

/** Zahlenband – aus Sicht der Anlage, nicht des Marktplatzes. */
export const CLUB_PROOF = [
  { value: '0 €', label: 'Für Golfanlagen', note: 'dauerhaft kostenlos, keine Provision' },
  { value: 'über 30', label: 'Anbieter', note: 'für den Start vorgemerkt' },
  { value: '5', label: 'Märkte in Europa', note: 'DE · AT · CH · NL · FR' },
  { value: '2 Minuten', label: 'Registrierung', note: 'danach einmalige Prüfung' },
];

export const CLUB_FEATURES = [
  {
    key: 'einmal',
    headline: 'Ein Vorgang statt zehn Telefonate',
    text:
      'Sie beschreiben Ihren Bedarf einmal – Menge, Termin, Budgetrahmen, gewünschte Leistungen. Alle passenden Anbieter sehen dieselbe Anfrage. Niemand ruft zurück, um zu fragen, was Sie eigentlich brauchen.',
  },
  {
    key: 'vergleich',
    headline: 'Angebote, die sich wirklich vergleichen lassen',
    text:
      'Weil alle auf dieselbe Ausschreibung antworten, stehen Preis, Lieferzeit, Garantie und Montage nebeneinander – in einer Tabelle statt in fünf verschiedenen PDF-Anhängen mit fünf verschiedenen Leistungsumfängen.',
  },
  {
    key: 'vorstand',
    headline: 'Die Vorstandssitzung wird kürzer',
    text:
      'Sie legen eine Übersicht vor, nicht einen Stapel. Wer welchen Preis für welche Leistung bietet, steht auf einem Blatt – die Diskussion dreht sich um die Entscheidung statt um das Sortieren.',
  },
  {
    key: 'vermerk',
    headline: 'Vergabevermerk auf Knopfdruck',
    text:
      'Alle Angebote, die Kriterien, die Entscheidung, das Datum – als fertiges Dokument für Vorstand, Kämmerer oder Prüfung. Gerade bei Vereinen und kommunal getragenen Anlagen ist das der Unterschied zwischen entscheiden und aufschieben.',
  },
  {
    key: 'frist',
    headline: 'Sie bestimmen den Zeitpunkt',
    text:
      'Sie setzen die Frist, bis wann Angebote eingehen sollen. Damit beschaffen Sie außerhalb der Saison und mit Vorlauf – statt im April, wenn die Maschine steht und jeder Preis akzeptiert wird.',
  },
  {
    key: 'geprueft',
    headline: 'Geprüfte Anbieter statt Massen-Mails',
    text:
      'Jede Anmeldung wird vor der Freischaltung einmalig geprüft. Ihre Anfrage geht an Fachanbieter, nicht in einen Verteiler – und Ihre Kontaktdaten bekommt niemand ungefragt.',
  },
];

/**
 * Der Finanzteil. Mechanismen statt Versprechen – jeder Punkt lässt sich
 * an der Plattform nachvollziehen.
 */
export const CLUB_MONEY = [
  {
    headline: 'Der Preis entsteht im Wettbewerb, nicht am Telefon',
    text:
      'Mehrere Anbieter kalkulieren auf dieselbe Spezifikation und wissen, dass sie nicht die Einzigen sind. Das ist ein anderer Ausgangspunkt als ein Einzelgespräch mit dem Anbieter, den man seit Jahren anruft.',
  },
  {
    headline: 'Die Nebenkosten stehen mit im Angebot',
    text:
      'Montage, Wartung pro Jahr, Garantie, Rücknahme des Altgeräts – all das ist Teil des Angebots. Der niedrigste Angebotspreis ist selten der günstigste Vertrag, und hier sehen Sie den Unterschied vor der Unterschrift.',
  },
  {
    headline: 'Keine Notbeschaffung zum Listenpreis',
    text:
      'Mit gesetzter Frist und Vorlauf kaufen Sie planvoll ein. Wer erst bestellt, wenn der Ballautomat mitten in der Saison ausfällt, zahlt den Aufschlag für Eile.',
  },
  {
    headline: 'Gemeinsam ausschreiben, gemeinsam günstiger',
    text:
      'Schreiben Nachbaranlagen dasselbe aus, zeigt FairwayBid das an. Aus zwei kleinen Bedarfen wird eine Menge, die einen anderen Preis rechtfertigt.',
  },
  {
    headline: 'Kein Beitrag, keine Provision',
    text:
      'Für Golfanlagen ist FairwayBid kostenlos, und auf Ihren Einkauf wird nichts aufgeschlagen. Der verhandelte Preis ist der Preis – FairwayBid verdient an den Mitgliedschaften der Anbieter.',
  },
];

export const CLUB_STEPS = [
  {
    title: 'Bedarf einstellen',
    text:
      'Kategorie wählen, beschreiben was Sie brauchen, Menge und Termin angeben und eine Frist setzen. Dauert wenige Minuten.',
  },
  {
    title: 'Angebote erhalten',
    text:
      'Die passenden Anbieter antworten mit Preis, Lieferzeit, Garantie und Montage – strukturiert und damit vergleichbar.',
  },
  {
    title: 'Vergleichen und vergeben',
    text:
      'Alle Angebote nebeneinander, das günstigste ist markiert. Sie entscheiden und ziehen sich den Vergabevermerk als Dokument.',
  },
];

export const CLUB_CLOSER = {
  headline: 'Ihre nächste Beschaffung steht ohnehin an.',
  text:
    'Die Frage ist nur, ob Sie sie wieder ertelefonieren oder einmal ausschreiben. Die Registrierung dauert zwei Minuten und kostet nichts.',
  cta: 'Als Golfanlage registrieren',
};
